import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import SEO from "../components/SEO";
import "./Tnc.css";

const Tnc = () => {
  return (
    <div>
      <SEO
        title="Terms and Conditions"
        description="The terms that govern purchases and use of the-brik.com, including orders, payment, shipping, and warranty."
        path="/tnc"
      />
      <Header />
      <div className="tnc-container">
        <h1>Terms and Conditions</h1>
        <p>Last Updated: January 1, 2025</p>

        <h2>1. Agreement to Terms</h2>
        <p>
          These Terms and Conditions constitute a legally binding agreement made between you (“you” or “Customer”) and The Brik (“we,” “us,” or “our”). These Terms govern your use of The Brik website (the “Site”) located at the-brik.com and apply to all transactions and sales of products offered through our Site. By accessing our Site or placing an order, you acknowledge that you have read, understood, and agree to be bound by these Terms and Conditions.
        </p>

        <h2>2. Intellectual Property Rights</h2>
        <p>
          The entire content of the Site—including text, images, graphics, logos, videos, and software—is the exclusive property of The Brik or its licensors. Any unauthorized use, reproduction, or distribution of any materials on the Site is strictly prohibited. All trademarks, service marks, and logos displayed on the Site are owned by The Brik or third parties.
        </p>

        <h2>3. User Representations and Responsibilities</h2>
        <p>
          By using the Site, you represent and warrant that all information you provide is accurate, current, and complete. You agree to update such information as necessary and to use the Site only for lawful purposes. You further represent that you have the legal capacity to enter into these Terms and that your use of the Site will not violate the rights of any third party.
        </p>

        <h2>4. Sales, Orders, and Payment</h2>
        <p>
          All orders placed through the Site are subject to acceptance by The Brik. We reserve the right to cancel or refuse any order for any reason, including but not limited to product availability, errors in product or pricing information, or suspected fraudulent activity. Payment for all orders must be made using our approved payment methods, and by placing an order, you agree to pay all applicable charges, including taxes and shipping fees, at the time of purchase.
        </p>

        <h2>5. Shipping, Delivery, and Handling</h2>
        <p>
          We use Pirate Ship in partnership with USPS to ship your orders. Orders are processed within 2-3 business days; however, during periods of high demand, processing may take between 1 to 2 weeks. Once an order is shipped, you will receive tracking information via email. Please note that estimated delivery times are provided for convenience only and may vary due to factors beyond our control.
        </p>

        <h2>6. Returns and Exchanges</h2>
        <p>
          All sales made through The Brik are final. We do not offer refunds. An exchange is available only if a product is defective, damaged, or destroyed upon delivery. To request an exchange, please contact us with your order number and provide evidence of the issue. We reserve the right to require the return of the defective product prior to issuing an exchange.
        </p>

        <h2>7. Prohibited Activities</h2>
        <p>
          You agree not to engage in any of the following activities in connection with the Site:
        </p>
        <ul>
          <li>
            Using the Site for any illegal or unauthorized purpose.
          </li>
          <li>
            Systematically collecting or harvesting data from the Site without our express written consent.
          </li>
          <li>
            Circumventing, disabling, or interfering with security-related features of the Site.
          </li>
          <li>
            Engaging in any activity that could damage, disable, or impair the functionality of the Site.
          </li>
        </ul>

        <h2>8. User-Generated Content</h2>
        <p>
          The Site may offer opportunities for you to post reviews, comments, or other content. By submitting any content, you grant The Brik a non-exclusive, worldwide, royalty-free, perpetual license to use, modify, reproduce, and distribute your content in connection with the Site and our business. You acknowledge that all user-generated content is non-confidential and must not infringe on any third-party rights.
        </p>

        <h2>9. Third-Party Websites and Content</h2>
        <p>
          The Site may contain links to third-party websites or display content provided by third parties. The Brik does not control and is not responsible for the content, accuracy, or opinions expressed on these sites, and the inclusion of such links does not imply an endorsement by The Brik.
        </p>

        <h2>10. Site Management and Modifications</h2>
        <p>
          We reserve the right to monitor and manage the Site to ensure compliance with these Terms. We may update, modify, or remove any content or features of the Site at any time without prior notice. Continued use of the Site following any changes signifies your acceptance of the revised Terms.
        </p>

        <h2>11. Governing Law</h2>
        <p>
          These Terms and Conditions, as well as any disputes arising out of your use of the Site or purchase of products, shall be governed by and construed in accordance with the laws of the State of Iowa, without regard to its conflict of law principles.
        </p>

        <h2>12. Dispute Resolution</h2>
        <p>
          In the event of a dispute, you agree to first contact us to seek an informal resolution. Should the dispute not be resolved amicably, you agree that any legal action shall be brought exclusively in the appropriate state or federal courts located in Iowa. Both parties waive any objection to jurisdiction or venue in these courts.
        </p>

        <h2>13. Disclaimer of Warranties</h2>
        <p>
          The Site and all products available on The Brik are provided on an “as is” and “as available” basis without any warranties, either express or implied. The Brik disclaims all warranties of merchantability, fitness for a particular purpose, and non-infringement. Your use of the Site and any purchase made through the Site is at your sole risk.
        </p>

        <h2>14. Limitations of Liability</h2>
        <p>
          Under no circumstances shall The Brik, its directors, employees, or agents be liable for any direct, indirect, incidental, special, or consequential damages arising from your use of the Site or the purchase of any products, even if advised of the possibility of such damages.
        </p>

        <h2>15. Indemnification</h2>
        <p>
          You agree to indemnify and hold harmless The Brik, its affiliates, directors, employees, and agents from any claims, damages, liabilities, losses, or expenses (including reasonable attorneys’ fees) arising from your use of the Site, your violation of these Terms, or your infringement of any rights of a third party.
        </p>

        <h2>16. Entire Agreement</h2>
        <p>
          These Terms and Conditions constitute the entire agreement between you and The Brik regarding your use of the Site and the purchase of products. They supersede any prior agreements, communications, or representations, whether oral or written.
        </p>

        <h2>17. Contact Us</h2>
        <p>
          If you have any questions or concerns about these Terms and Conditions or any aspect of our products and services, please contact us at:
        </p>
        <address>
          <strong>The Brik LLC</strong><br />
          119 Stanton Avenue<br />
          Ames, Iowa, 50014<br />
          <a href="mailto:asray@the-brik.com">asray@the-brik.com</a>
        </address>
      </div>
      <Footer />
    </div>
  );
};

export default Tnc;
